'use strict';

var _pick = require('lodash/pick');
var consts = require('./consts.js');

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-statements */
const mockDomain = 'http://test.com';
const getLoginUrl = (options) => {
    const { webPath, returnUrl, loginType, esiaType, isNewWindow = false, isCrossDomains, otac, ot, pinDisabled, placement, productId, 
    // eslint-disable-next-line @typescript-eslint/naming-convention
    acr_values, hint, prompt, prefix = consts.AUTH_ROUTER_PREFIX_DEFAULT, alfaClient, } = options || {};
    const hasWebPath = Boolean(webPath);
    const loginUrl = new URL(`${prefix}${consts.ROUTES.LOGIN}`, hasWebPath ? webPath : mockDomain);
    if (returnUrl) {
        loginUrl.searchParams.append(consts.QUERY.RETURN_URL, returnUrl);
    }
    if (loginType) {
        loginUrl.searchParams.append(consts.QUERY.LOGIN_TYPE, loginType);
    }
    if (esiaType) {
        loginUrl.searchParams.append(consts.QUERY.ESIA_TYPE, esiaType);
    }
    if (ot) {
        loginUrl.searchParams.append(consts.QUERY.OT, ot);
    }
    if (otac) {
        loginUrl.searchParams.append(consts.QUERY.OTAC, otac);
    }
    if (acr_values) {
        loginUrl.searchParams.append(consts.QUERY.ACR_VALUES, acr_values);
    }
    if (hint) {
        loginUrl.searchParams.append(consts.QUERY.HINT, hint);
    }
    if (prompt) {
        loginUrl.searchParams.append(consts.QUERY.PROMPT, prompt);
    }
    if (isNewWindow) {
        loginUrl.searchParams.append(consts.QUERY.TYPE, consts.AUTHENTICATION_UI_TYPE.POPUP);
    }
    if (typeof isCrossDomains === 'boolean') {
        loginUrl.searchParams.append(consts.QUERY.CROSS_DOMAINS_ACTIONS_ENABLED, isCrossDomains ? '1' : '0');
    }
    if (typeof pinDisabled === 'boolean') {
        loginUrl.searchParams.append(consts.QUERY.PIN_DISABLED, pinDisabled.toString());
    }
    if (placement) {
        loginUrl.searchParams.append(consts.QUERY.PLACEMENT, placement);
    }
    if (productId) {
        loginUrl.searchParams.append(consts.QUERY.PRODUCT_ID, productId);
    }
    if (alfaClient) {
        loginUrl.searchParams.append(consts.QUERY.ALFA_CLIENT, alfaClient);
    }
    return hasWebPath ? loginUrl.toString() : `${loginUrl.pathname}${loginUrl.search}`;
};
const getLogoutUrl = (options) => {
    const { webPath, prefix = consts.AUTH_ROUTER_PREFIX_DEFAULT, isNewWindow = false, returnUrl } = options || {};
    const hasWebPath = Boolean(webPath);
    const logoutUrl = new URL(`${prefix}${consts.ROUTES.LOGOUT}`, hasWebPath ? webPath : mockDomain);
    if (returnUrl) {
        logoutUrl.searchParams.append(consts.QUERY.RETURN_URL, returnUrl);
    }
    if (isNewWindow) {
        logoutUrl.searchParams.append(consts.QUERY.TYPE, consts.AUTHENTICATION_UI_TYPE.POPUP);
    }
    return hasWebPath ? logoutUrl.toString() : `${logoutUrl.pathname}${logoutUrl.search}`;
};
const getLoadingUrl = (options) => {
    const { webPath, prefix = consts.AUTH_ROUTER_PREFIX_DEFAULT, timeoutExpired } = options || {};
    const hasWebPath = Boolean(webPath);
    const loadingUrl = new URL(`${prefix}${consts.ROUTES.LOADING}`, hasWebPath ? webPath : mockDomain);
    if (timeoutExpired)
        loadingUrl.searchParams.append(consts.QUERY.TIMEOUT_EXPIRED, timeoutExpired.toString());
    return hasWebPath ? loadingUrl.toString() : `${loadingUrl.pathname}${loadingUrl.search}`;
};
/**
 * @deprecated Перенести генерауию урла в AuthApiClient
 */
const getSilentSignInUrl = (options) => {
    const { webPath, prefix = consts.AUTH_ROUTER_PREFIX_DEFAULT } = options || {};
    const hasWebPath = Boolean(webPath);
    const silentSignInUrl = new URL(`${prefix}${consts.ROUTES.SILENT_SIGNIN}`, hasWebPath ? webPath : mockDomain);
    return hasWebPath ? silentSignInUrl.toString() : `${silentSignInUrl.pathname}`;
};
/**
 * @deprecated Перенести генерауию урла в AuthApiClient
 */
const getSilentSignInVerifyUrl = (options) => {
    const { webPath, prefix = consts.AUTH_ROUTER_PREFIX_DEFAULT } = options || {};
    const hasWebPath = Boolean(webPath);
    const silentSignInVerifyUrl = new URL(`${prefix}${consts.ROUTES.SILENT_SIGNIN_VERIFY}`, hasWebPath ? webPath : mockDomain);
    return hasWebPath ? silentSignInVerifyUrl.toString() : `${silentSignInVerifyUrl.pathname}`;
};
/**
 * Cleanup user secret data
 * @param data - user data
 * @param keys - accepted keys
 * @returns IPublicUser - clean user data
 */
function formatUserData(data, keys = []) {
    const USER_CLAIMS = [
        'email',
        'phone_number',
        'exp',
        'expires',
        'name',
        'nickname',
        'preferred_username',
        'role',
        'sub',
        'given_name',
        'family_name',
        'avatar',
    ];
    const user = _pick(data, [...USER_CLAIMS, ...keys]);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { given_name, family_name, ...rest } = user;
    return {
        ...rest,
        ...(given_name ? { first_name: given_name } : {}),
        ...(family_name ? { last_name: family_name } : {}),
    };
}

exports.formatUserData = formatUserData;
exports.getLoadingUrl = getLoadingUrl;
exports.getLoginUrl = getLoginUrl;
exports.getLogoutUrl = getLogoutUrl;
exports.getSilentSignInUrl = getSilentSignInUrl;
exports.getSilentSignInVerifyUrl = getSilentSignInVerifyUrl;
//# sourceMappingURL=helpers.js.map
